// extracted by mini-css-extract-plugin
export var infoRow = "_qg-2";
export var labelContainer = "_qg-0";
export var rightInfo = "_qg-1";